export const GOOGLE_MAP_SCRIPT_BASE_URL = 'https://maps.googleapis.com/maps/api/js'
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE ?? ''
